module.exports = __webpack_public_path__ + "static/media/behind-the-white-line-tile.2ad36f26.jpg";